import KeyType from './KeyType.js'
import ModuleCenter from './ModuleCenter.js';
import FieldConfigs from './FieldConfigs.js';
import DataType from '../data/DataType.js';
import FieldRelation from './FieldRelation.js';

export const createDefaultOption = (config, dataField)=> {
    const options = {field:config.code, name:config.name, dataField:dataField};
    switch (config.type) {
        default: Object.assign(options, FieldConfigs.LABEL); break;
        case DataType.NUMBER: Object.assign(options, FieldConfigs.NUMBER); break;
        case DataType.CURRENCY: Object.assign(options, FieldConfigs.CURRENCY); break;
        case DataType.STRING: Object.assign(options, FieldConfigs.INPUT); break;
        case DataType.TEXT: Object.assign(options, FieldConfigs.TEXTAREA); break;
        case DataType.DATE: Object.assign(options, FieldConfigs.DATE); break;
        case DataType.TIME: Object.assign(options, FieldConfigs.TIME); break;
        case DataType.DATETIME: Object.assign(options, FieldConfigs.DATETIME); break;
        case DataType.BOOLEAN: Object.assign(options, FieldConfigs.SWITCH); break;
        case DataType.TAG: Object.assign(options, FieldConfigs.TAG); break;
    } 
    return options;
}
export const createRelDefaultOption = (config, isMultiple, isStatic, dataField)=> {
    const options = {field:config.code, name:config.name, rel:config.rel, multiple:isMultiple, static:isStatic, dataField:dataField};
    const v = (isMultiple ? 2 : 0) | (isStatic ? 1 : 0);
    switch (v) {
        case 0: Object.assign(options, FieldConfigs.SELECTION); break;
        case 1: Object.assign(options, FieldConfigs.SELECT); break;
        case 2: Object.assign(options, FieldConfigs.MULTISELECTION); break;
        case 3: Object.assign(options, FieldConfigs.MULTISELECT); break;
    }
    return options;
}
export const createDefaultListOption = (config, dataField)=> {
    const options = {field:config.code, name:config.name, sortable:config.sortable, sort:config.sort, dataField:dataField};
    return Object.assign(options, FieldConfigs.LABEL);
}
export const createRelDefaultListOption = (config, isMultiple, isStatic, dataField)=> {
    const options = {field:config.code, name:config.name, rel:config.rel, multiple:isMultiple, static:isStatic, dataField:dataField};
    if (isMultiple) return Object.assign(options, FieldConfigs.TAG);
    return Object.assign(options, FieldConfigs.LABEL);
}

const getKeyType = (config)=> {
    if (config.key) return KeyType.PK;
    if (config.rel) return KeyType.FK;
    return KeyType.NK;
}

export const getRelatedInfo = (rel, rs)=> {
    if (!rel) return null;
    if (!/^(\w+)\.(\w+)(?:\:(\w+))?$/.test(rel)) return null;
    const moduleCode = RegExp.$1;
    const fieldCode = RegExp.$2;
    const relField = RegExp.$3;
    const relInfo = ModuleCenter.test(moduleCode, fieldCode);
    if (!relInfo) {
        console.log('module field', moduleCode + '.' + fieldCode, 'is not defined.');
        return null;
    }
    if (relField) relInfo.relField = relField;
    relInfo.rs = rs || FieldRelation.FR_1v1;
    return relInfo;
}

class DataField {
    _config = null;
    _code = null;
    _name = null;
    _type = null;
    _keyType = KeyType.NK;
    _relInfo = null;
    _rules = null;
    _defaultOptions = null;
    _defaultListOptions = null;

    _relModuleCode = null;
    _relFieldCode = null;
    // _dataOptions = null;

    constructor(config) {
        this._code = config.code;
        this._name = config.name;
        this._sortable = config.sortable;
        this._sort = config.sort;
        this._foreignField = config.rel;
        if (config.rel) {
            const relInfo = config.rel.split(/\./);
            this._relModuleCode = relInfo[0];
            this._relFieldCode = relInfo[1];
        }
        this._type = config.type || DataType.STRING;
        this._keyType = getKeyType(config);
        this._rules = config.rules;
        this._config = config;
        if (!config.rel) {
            this._defaultOptions = createDefaultOption(config, this);
            this._defaultListOptions = createDefaultListOption(config, this);
        }
        // type/validate/maxLength/required/expression&rules set by config here
        // this._dataOptions = config.dataOptions;
    }

    getName() {
        return this._name;
    }
    getDataType() {
        return this._type;
    }
    getSortable() {
        return this._sortable;
    }
    getSort() {
        return this._sort;
    }
    getRules() {
        return this._rules;
    }

    resetRelDefaultOptions(isMultiple, isStatic) {
        this._defaultOptions = createRelDefaultOption(this._config, isMultiple, isStatic, this);
        this._defaultListOptions = createRelDefaultListOption(this._config, isMultiple, isStatic, this);
    }

    getRelatedInfo() {
        if (!this._relInfo && this._keyType == KeyType.FK || this._keyType == KeyType.PK) {
            this._relInfo = getRelatedInfo(this._config.rel, this._config.rs);
            // if (this._relInfo) this._foreignField = this._relInfo.module.getCode() + '.' + this._relInfo.field.getCode();
        }
        return this._relInfo;
    }
    setDynamicRelatedInfo(dynamicRelatedInfo) {
        this._dynamicRelInfo = dynamicRelatedInfo;
    }
    getDynamicRelatedInfo() {
        return this._dynamicRelInfo;
    }
    getDynamicRelatedInfoBy(module) {
        if (!this._dynamicRelInfo) return null;
        for (const info of this._dynamicRelInfo) {
            if (info.module.getCode() == module) return info;
        }
        return null;
    }

    getForeignField() {
        // if (!this._relInfo && this._keyType == KeyType.FK) {
        //     this.getRelatedInfo();
        // }
        return this._foreignField;
    }
    getForeignFieldCode() {
        return this._relFieldCode;
    }
    getDynamicForeignFieldCode(module) {
        if (!this._dynamicRelInfo) return null;
        for (const info of this._dynamicRelInfo) {
            if (info.module.getCode() == module) return info.field.getCode();
        }
        return null;
    }
    getRelFieldCode(module) {
        return this._relFieldCode || this.getDynamicForeignFieldCode(module);
    }
    
    isPrimaryKey() {
        return this._keyType == KeyType.PK;
    }
    isForeignKey() {
        return this._keyType == KeyType.FK;
    }
    getCode() {
        return this._code;
    }
    getDefaultOption() {
        return Object.assign({}, this._defaultOptions);
    }
    getDefaultListOption() {
        return Object.assign({}, this._defaultListOptions);
    }

    getModule() {
        return this._relInfo ? this._relInfo.module : null;
    }
}

export default DataField;